import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as env from 'src/environments/environment';
import { ClaimRewardSheetComponent } from '../components/claim-reward-sheet/claim-reward-sheet.component';
import { NavigationEnd, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { SessionInfo, personalInfo } from 'src/app/models/User';
import { LoginService } from '../services/checkout-services/login.service';
import { MobileComponent } from '../pages/checkout-process/mobile/mobile.component';
import { ApplicationStateService } from '../services/application-state.service';
import { MatBottomSheet } from '@angular/material';
import { Utils } from '../Utils';
import { AppConfigService } from '../app-config.service';
import { environment } from 'src/environments/environment';
import { ExternalRouterService } from '../services/external-router.service';
import { AuthService } from '../services/auth.service';
@Component({
  selector: 'app-mobile-sidebar',
  templateUrl: './mobile-sidebar.component.html',
  styleUrls: ['./mobile-sidebar.component.scss']
})


export class MobileSidebarComponent {
path = '/login';
user = 'Login';
  userLogged = true;
  session = new SessionInfo();
  private loginService: LoginService;
  
    public isMobileResolution = false;
  
  constructor(
    private router: Router,
    private _cookie: CookieService,
     private applicationStateService: ApplicationStateService,
     private _bottomSheet: MatBottomSheet,
     private bottomSheet: MatBottomSheet, 
     private appConfigService: AppConfigService,
     private externalRouter: ExternalRouterService,
     private authenticationService: AuthService,
  ){

    this.isMobileResolution = this.applicationStateService.getIsMobileResolution();
     router.events.subscribe((val) => {
          if (val instanceof NavigationEnd) {
            if (this._cookie.get('UserID') && this.userLogged) {
              
              this.path = '/account/order';
              this.session.userId = this._cookie.get('UserID');
              this.session.Authorization = this._cookie.get('Authorization');
    
              this.loginService.get(this.session)
                .subscribe(x => this.user = x.body.firstName);
              this.userLogged = false;
            }
            if (!this._cookie.get('UserID')) {
              this.user = 'Login';
              this.path = '/login';
              this.userLogged = true;
            }
          }
        });
  }
  @Input() sidebarOpen: boolean = false;
  @Output() closeSidebar = new EventEmitter<void>();

  activeMenu: string | null = null;
 

  toggleMenu(menu: string) {
    this.activeMenu = this.activeMenu === menu ? null : menu;
  }

get isUserLoggedIn(): boolean {
  return !!this._cookie.get('UserID');
}

  


 login() {
    this.rzpLogin();
  }
  rzpLogin() {
    if (this.applicationStateService.getIsMobileResolution()) {
      if (this._cookie.get('UserID')) {
        this.router.navigate(['/my-account']);
        
      } else {
        const sheet = this._bottomSheet.open(MobileComponent);
        sheet.backdropClick().subscribe(() => {
          sheet.dismiss()
        });
      }
    } else {
      this.router.navigate(['/login']);
    }
    
  }



  close() {
    this.closeSidebar.emit();
  }


  mobileClaimReward = env.environment.lead.mobileClaimReward;

   claimNow() {
    this.bottomSheet.open(ClaimRewardSheetComponent, {

    });
  }


  gotoCart() {
    
      const isMagicCheckoutEnabled = this.appConfigService.config.MAGIC_CHECKOUT_ENABLED != null
        ? this.appConfigService.config.MAGIC_CHECKOUT_ENABLED
        : environment.MAGIC_CHECKOUT_ENABLED;
  
      if (isMagicCheckoutEnabled) {
        let x = Utils.isLandedFromQuickBuyLink(this.externalRouter);
        if (x) {
          return;
        }
        this.router.navigate(['/cart']);
      }
      else {
        if (this.applicationStateService.getIsMobileResolution()) {
          Utils.checkOutInMobile('', this.authenticationService, this._cookie, this.externalRouter);
        }
        else {
          Utils.checkOutInDesktop("", this._cookie, this.externalRouter);
        }
      }
    }
    showForm(){
       const redirect= "https://wa.me/917217760961?text="+Utils.getWhatAppHiiText();// + str1;
       window.open(redirect, "_blank");
     //  this._bottomSheet.open(LeadInfoComponent);
     }
     navigateToContact() {
  this.router.navigate(['/contact-us']);
}

gotoProduct(productId: string) {
  this.router.navigate(['/gps-tracking-devices', productId]);
}
goToHome() {
  this.router.navigate(['/']);
}




}
